<div class="form-content-item">
  <div class="form-header-item">
    <div *ngIf="projectId" class="header-content">
      <app-breadcrumbs [items]="breadcrumbItems"></app-breadcrumbs>
      <span class="unsaved-badge" role="status">
        <ng-container *ngIf="hasUnsavedChanges">
          <mat-icon>error_outline</mat-icon>
          {{ 'project_unsaved_changes' | translate }}
        </ng-container>
      </span>
      <div class="div-btns-top">
        <action-bar
          [showSave]="true"
          [showShare]="projectId && canShare"
          [showDuplicate]="true"
          [showDelete]="true"
          [showSwitch]="true"
          [showPublish]="true"
          [showExport]="true"
          (onSave)="clickSave()"
          (onShare)="onShare()"
          (onDuplicate)="onDuplicateProject()"
          (onDelete)="onDeleteDialog()"
          (onSwitch)="changeProjectAgencyOwner()"
          (onPublish)="onPublish()"
          (onExport)="onExport()"></action-bar>
      </div>
    </div>
  </div>
</div>

<div class="project-container">
  <div class="step-progress-bar">
    <ng-container *ngFor="let step of steps; let i = index">
      <div class="item" [class.current]="i === currentStep" [class.past]="i < currentStep" [class.disabled]="!isStepAccessible(i)">
        <div [matTooltip]="getStepTooltip(i)" [matTooltipDisabled]="!getStepTooltip(i)">
          <div class="content" [class.clickable]="isStepAccessible(i)" (click)="onStepClick(i)">
            {{ i + 1 }}
          </div>
        </div>
        <p class="title">
          {{ step | translate }}
        </p>
      </div>
      <div class="separator" *ngIf="i < steps.length - 1" [class.current]="i === currentStep" [class.past]="i < currentStep"></div>
    </ng-container>
  </div>

  <div class="autosave-row" *ngIf="projectId && currentStep !== PROJECT_STEPS.RESULT">
    <mat-slide-toggle appConfirmToggle color="primary" [checked]="autoSaveEnabled" [disabled]="autoSaveBusy" [matTooltip]="'project_autosave_hint' | translate" (toggleChange)="onAutoSaveToggle()">
      {{ 'project_autosave_label' | translate }}
    </mat-slide-toggle>
  </div>

  <div class="project-error-banner" *ngIf="projectHasError && currentStep !== PROJECT_STEPS.RESULT">
    {{ 'project_error_has_errors' | translate }}
  </div>

  <app-project-step-project
    *ngIf="currentStep === PROJECT_STEPS.PROJECT"
    [projectForm]="projectForm"
    [isFromCallForTenders]="currentProject?.isFromCallForTenders === true"
    [projectTypes]="projectTypes"
    [databases]="databases"
    [filteredContractors]="filteredContractors"
    [projectId]="projectId"
    [projectStatuses]="projectStatuses"
    [currentProject]="currentProject"
    (onSubmit)="onSubmit()"
    (onSave)="clickSave()"
    (onDelete)="onDelete()"
    (onNextStep)="goToNextStep()"
    (onPreviousStep)="goToPreviousStep()">
  </app-project-step-project>

  <app-project-step-solutions
    *ngIf="currentStep === PROJECT_STEPS.SOLUTION"
    [projectForm]="projectForm"
    [projectId]="projectId"
    [currentItem]="currentProject"
    [autoSaveEnabled]="autoSaveEnabled"
    [flushChanges]="flushChanges"
    (onNextStep)="goToNextStep()"
    (onPreviousStep)="goToPreviousStep()"
    (onSaveProject)="handleSaveFromSolutions($event.item, $event.silent)"
    (onEquipmentProofPending)="addPendingEquipmentProof($event)">
  </app-project-step-solutions>

  <app-project-step-result *ngIf="currentStep === PROJECT_STEPS.RESULT" [projectForm]="projectForm" [projectId]="projectId" (onPreviousStep)="goToPreviousStep()"> </app-project-step-result>

  <img src="assets/img/project-illustration.png" alt="Project Illustration" class="illustration" />
</div>
